import { render, staticRenderFns } from "./ChallengeLeaderboard.vue?vue&type=template&id=3c974201&scoped=true&"
import script from "./ChallengeLeaderboard.vue?vue&type=script&lang=js&"
export * from "./ChallengeLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeLeaderboard.vue?vue&type=style&index=0&id=3c974201&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c974201",
  null
  
)

export default component.exports